import { convertPriceFormat } from "utils/common";

const formattedWeight = (weight: number, t: Function) => {
  return weight ? `${convertPriceFormat(weight)} ${t("GRAM")}` : `0 ${t("GRAM")}`;
};

export default formattedWeight;
